var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.charts),function(chart,index){return _c('AppChart',{key:index,staticClass:"column",class:_vm.charts.length === 1 ? 'is-full' : _vm.fullSize === true ? 'is-half' : 'is-one-third',attrs:{"chart":chart}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }